import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import './index.css';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from 'react-redux';
import store from './store';
import { detect } from 'detect-browser';
import Countdown from 'react-countdown';
import PopUp from './Popup/logoutPopup'

const browser = detect();

const Completionist = () => 
  <PopUp
    content={
      <>
        <b id="title">
          1 hour time limit exceeded
          <br />
        </b>
        <button
          id="logoutButton2"
          className="logoutButton"
          onClick={() => {
            window.location.reload(false);
          }}
        >
          <b id="title">
            OKAY
          </b>
        </button>
      </>
    }
  />

// handle the case where we don't detect the browser
// if (browser.name.includes('edge') || browser.name.includes('chrome')) {
  // try {
  // ReactDOM.render(
  //   <Provider store={store}>
  //     <HashRouter>
  //       <App />
  //       <footer className="footer">
  //         <Countdown date={Date.now() + 1000 * 60 * 50}>
  //           <div className='countdown'>
  //             <Completionist />
  //           </div>
  //         </Countdown>
  //       </footer>
  //     </HashRouter>
  //   </Provider>,
  //   document.getElementById('root')
  // ); 
  // } catch (error) {
  //   console.log(error);
  // } 

  try {
    ReactDOM.createRoot(
      document.getElementById("root"),
    )
    .render(
      <Provider store={store}>
        <HashRouter>
          <App />
          <footer className="footer">
            <Countdown date={Date.now() + 1000 * 60 * 50}>
              <div className='countdown'>
                <Completionist />
              </div>
            </Countdown>
          </footer>
        </HashRouter>
      </Provider>
    );
  } catch (error) {
    console.log(error);
  } 

reportWebVitals();
